import React from "react";
import ImageUploadLoader from "../Common/Loaders/ImageUploadLoader";
import { blurMessages } from "./constants";

const ImageUploadStep = ({
  formData,
  blurTextIndex,
  stepIndex,
  moveNext,
  handleFileUpload,
  handleDragOver,
  handleDragDrop,
  removeImage,
  rotateImage,
  rotateImageLeft,
  sizeChartRequired,
  sizeChartFile,
  sizeChartError,
  onSizeChartUpload,
}) => {
  return (
    <div className="step-panel">
      <div className="step-header">
        <h2>Upload Product Images</h2>
        <p>Add high-quality images of your product</p>
      </div>
      <div
        id="image-upload"
        className="upload-area"
        onDragOver={handleDragOver}
        onDrop={handleDragDrop}
        onClick={() => {
          stepIndex === 0 && moveNext();
          !formData.imageProcessing &&
            document.getElementById("file-input").click();
        }}
      >
        <input
          id="file-input"
          type="file"
          accept="image/*"
          capture="environment"
          multiple
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
        {formData.imageProcessing ? (
          <ImageUploadLoader
            messages={blurMessages}
            activeIndex={blurTextIndex}
          />
        ) : formData.uploadedImages.length > 0 ? (
          <div className="image-preview-container">
            {formData.uploadedImages.map((img, index) => (
              <div key={index} className="image-preview">
                <img src={img} alt={`Product ${index + 1}`} />
                
                {/* Delete Button */}
                <span
                  className="image-cross"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeImage(index);
                  }}
                >
                  ×
                </span>
                
                {/* 🔄 LEFT ROTATE BUTTON (Counter-Clockwise) */}
                <span
                  className="rotate-left-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    rotateImageLeft(index);
                  }}
                  title="Rotate Left"
                >
                  ↺
                </span>
                
                {/* 🔄 RIGHT ROTATE BUTTON (Clockwise) */}
                <span
                  className="rotate-right-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    rotateImage(index);
                  }}
                  title="Rotate Right"
                >
                  ↻
                </span>
                
                <span
                  className={`blur-badge ${
                    formData.blurStatuses[index] ? "blurred" : "ok"
                  }`}
                >
                  {formData.blurStatuses[index] ? "Blur!" : "OK"}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <div className="upload-placeholder">
            <div className="upload-icon">📷</div>
            <h3>Drop Images OR Click to Upload</h3>
            <p>JPG, PNG, WebP • Max 5MB</p>
          </div>
        )}
      </div>

      {/* ✅ SIZE CHART UPLOAD SECTION (Added Below Images) */}
      {sizeChartRequired === "required" && (
        <div className="size-chart-upload-container mt-4 p-3 border rounded">
          <label className="fw-bold mb-2">Size Tag (Required)</label>
          <div className="d-flex align-items-center gap-3">
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp,application/pdf"
              onChange={onSizeChartUpload}
              className="form-control"
              style={{ width: "auto" }}
            />
            {sizeChartFile && (
              <span className="text-success">✓ {sizeChartFile.file.name}</span>
            )}
          </div>
          {sizeChartError && (
            <div className="text-danger small mt-2">{sizeChartError}</div>
          )}
          {sizeChartRequired === "required" && !sizeChartFile && (
            <div className="text-warning small mt-2">
              Please upload size Tag before proceeding
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImageUploadStep;